<template>
  <el-container>
    <el-header class="header">
      <img class="img_logo" src="@/assets/images/logo.png" alt=""/>
      <img class="img_rectangle" src="@/assets/images/rectangle.png" alt=""/>
      <img class="img_title" src="@/assets/images/title.png" alt=""/>
      <img class="img_osp" src="@/assets/images/osp_logo.png" alt=""/>
    </el-header>
    <img class="hf_logo2" src="@/assets/images/hf_logo2.png" alt=""/>
    <el-main class="main">
      <el-main>
        <h6 class="text">您正在通过身份证号注册</h6>
        <el-input class="input" placeholder="请输入身份证信息" v-model="idCard"></el-input>
        <el-button class="but1" @click="registerByIdCard">
          <span class="sp">提交验证身份</span>
        </el-button>
      </el-main>
      <el-main v-if="tableData.length > 0 && tableData[0].posName !== ''" class="table">
        <el-button class="but2">
          <img class="three_lever" src="@/assets/images/three_lever.png" alt=""/>
          <span class="sp1">员工的身份信息</span>
        </el-button>
        <el-table :data="tableData"
                  :header-cell-style="{'text-align':'center','background-color':'rgb(245, 245, 245)'}"
                  :cell-style="{'text-align':'center'}"
                  style="width: 100%;border: 1px solid rgb(196, 196, 196); border-top: none">
          <el-table-column
            prop="personName"
            label="姓名">
          </el-table-column>
          <el-table-column
            prop="companyName"
            label="公司">
          </el-table-column>
          <el-table-column
            prop="personPhone"
            label="手机号">
          </el-table-column>
          <el-table-column
            prop="posName"
            label="职务">
          </el-table-column>
        </el-table>
      </el-main>
      <el-main v-if="tableData.length > 0 && tableData[0].posName === ''" class="table">
        <el-button class="but2">
          <img class="three_lever" src="@/assets/images/three_lever.png" alt=""/>
          <span class="sp1">您的身份信息</span>
        </el-button>
        <el-table :data="tableData"
                  :header-cell-style="{'text-align':'center','background-color':'rgb(245, 245, 245)'}"
                  :cell-style="{'text-align':'center'}"
                  style="width: 100%;border: 1px solid rgb(196, 196, 196); border-top: none">
          <el-table-column
            prop="companyName"
            label="公司"
            min-width="30%">
          </el-table-column>
          <el-table-column
            prop="customerName"
            label="姓名"
            min-width="15%">
          </el-table-column>
          <el-table-column
            prop="customerPhone"
            label="手机号"
            min-width="20%">
          </el-table-column>
          <el-table-column
            prop="personName"
            label="业务员"
            min-width="15%">
          </el-table-column>
          <el-table-column
            prop="personPhone"
            label="业务员手机号"
            min-width="20%">
          </el-table-column>
        </el-table>
      </el-main>
      <el-main>
        <el-button class="but but3" @click="sendPassword">
          <span class="sp">获取账号及密码</span>
        </el-button>
        <span class="sp2">发送您绑定的手机号</span>
        <el-main class="m1"></el-main>
        <el-button class="but but4" @click="sendPasswordToPerson">
          <span class="sp">生成密码并发送到业务员手机代收</span>
        </el-button>
        <span class="sp2">如果您是客户，同时没有绑定手机号，请发送到您的业务员处，同时向业务员要密码！</span>
        <el-divider class="div"></el-divider>
        <el-button class="but but5" @click="doLogin">
          <span class="sp">注册成功并登录</span>
        </el-button>
        <span class="sp2">提示：请确保已绑定手机号！</span>
      </el-main>
    </el-main>
  </el-container>
</template>

<script>

import {registerByIdCard, sendPasswordByEAS, sendPasswordMessage} from "../../../api/system/register";

export default {
  data(){
    return{
      idCard:'',
      userNumber:'',
      tableData:[],
      username:'',
      userType:'',
      cusPhoneList:[],
      perPhoneList:[]
    }
  },
  methods:{
    registerByIdCard(){
      if(this.idCard === ''){
        return
      }
      registerByIdCard({
        idCard:this.idCard
      }).then(res => {
        // console.log(res.data)
        this.tableData = res.data
        if(this.tableData.length > 0){
          //判断是客户还是业务员
          if(this.tableData[0].posName === ''){
            this.username = this.tableData[0].customerNumber
            this.userType = 2
          }else{
            this.username = this.tableData[0].personNumber
            this.userType = 1
            if(this.tableData[0].depName.indexOf("财务") > -1){
              // console.log("财务")
              this.userType = 3
            }else if(this.tableData[0].posName.indexOf("协调") > -1 || this.tableData[0].posName.indexOf("销售内勤") > -1 || this.tableData[0].posName.indexOf("营业室") > -1){
              // console.log("协调")
              this.userType = 4
            }
          }
        }
        //初始化
        this.cusPhoneList = []
        this.perPhoneList = []
        //客户手机号列表
        for(let i = 0; i < this.tableData.length; i++){
          this.cusPhoneList.push(this.tableData[i].customerPhone)
          this.cusPhoneList = Array.from(new Set(this.cusPhoneList))
        }
        // console.log(this.cusPhoneList)
        //业务员手机号列表
        for(let i = 0; i < this.tableData.length; i++){
          this.perPhoneList.push(this.tableData[i].personPhone)
          this.perPhoneList = Array.from(new Set(this.perPhoneList))
        }
        // console.log(this.perPhoneList)
      }).catch(error => {
        console.log(error)
      });
    },
    // sendPasswordByEAS(val){
    //   sendPasswordByEAS({
    //     userNumber: this.username,
    //     phone: val,
    //     userType: this.userType
    //   }).then(res => {
    //     // console.log(res)
    //     if(res.code === 200){
    //       this.$modal.msgSuccess("您的账号密码已发送，请注意查收");
    //     }else{
    //       this.$modal.msg("未查询到您的账号信息")
    //     }
    //   }).catch(() => {
    //     console.log("未查询到您的账号信息")
    //   });
    // },
    //发短信给用户
    sendPassword(){
      if(this.username === null || this.username === ''){
        this.$modal.msg("请先核对身份")
        return;
      }
      //业务员
      if(this.userType === 1 || this.userType === 3 || this.userType === 4){
        if(this.perPhoneList[0] === null || this.perPhoneList[0] === ''){
          this.$modal.msg("请先维护手机号")
          return;
        }
        sendPasswordByEAS({
          phone:this.perPhoneList[0],
          userNumber:this.username,
          userType:this.userType
        }).then(res => {
          if(res.code === 200){
            this.$modal.msgSuccess("您的账号密码已发送，请注意查收");
            for(let i = 1; i < this.perPhoneList.length; i++){
              if(this.perPhoneList[i] != null) {
                // console.log(this.perPhoneList[i])
                sendPasswordByEAS({phone:this.perPhoneList[i], userNumber:this.username, userType:this.userType})
              }
            }
          }
        })
      }else if(this.userType === 2){
        if(this.cusPhoneList[0] === null || this.cusPhoneList[0] === ''){
          this.$modal.msg("请先维护手机号")
          return;
        }
        sendPasswordByEAS({
          phone:this.cusPhoneList[0],
          userNumber:this.username,
          userType:this.userType
        }).then(res => {
          if(res.code === 200){
            this.$modal.msgSuccess("您的账号密码已发送，请注意查收");
            for(let i = 1; i < this.cusPhoneList.length; i++){
              if(this.cusPhoneList[i] != null) {
                // console.log(this.cusPhoneList[i])
                sendPasswordByEAS({phone:this.cusPhoneList[i], userNumber:this.username, userType:this.userType})
              }
            }
          }
        })
      }
    },
    //发送短信给业务员
    sendPasswordToPerson(){
      if(this.username === null || this.username === ''){
        this.$modal.msg("请先核对身份")
        return;
      }
      if(this.perPhoneList[0] === null || this.perPhoneList[0] === ''){
        this.$modal.msg("请先维护手机号")
        return;
      }
      sendPasswordByEAS({
        phone:this.perPhoneList[0],
        userNumber:this.username,
        userType:this.userType
      }).then(res => {
        if(res.code === 200){
          this.$modal.msgSuccess("您的账号密码已发送，请注意查收");
          for(let i = 1; i < this.perPhoneList.length; i++){
            if(this.perPhoneList[i] != null) {
              // console.log(this.perPhoneList[i])
              sendPasswordByEAS({phone:this.perPhoneList[i], userNumber:this.username, userType:this.userType})
            }
          }
        }
      })
    },
    // sendPassword(status){
    //   if(this.username === null || this.username === ''){
    //     this.$modal.msg("请先核对身份")
    //     return;
    //   }
    //   let promiseList = [];
    //   //发给自己
    //   if(status == 'self'){
    //     if(this.userType === 1){
    //       this.perPhoneList.forEach(phone => {
    //         // console.log(phone+'-'+this.username+'-'+this.userType)
    //         promiseList.push(sendPasswordByEAS({phone:phone,userNumber:this.username,userType:this.userType}));
    //       })
    //     }else if(this.userType === 2){
    //       this.cusPhoneList.forEach(phone => {
    //         // console.log(phone+'-'+this.username+'-'+this.userType)
    //         promiseList.push(sendPasswordByEAS({phone:phone,userNumber:this.username,userType:this.userType}));
    //       })
    //     }
    //   }
    //   //业务员代收
    //   else if(status == 'others'){
    //     this.perPhoneList.forEach(phone => {
    //       // console.log(phone+'-'+this.username+'-'+this.userType)
    //       promiseList.push(sendPasswordByEAS({phone:phone,userNumber:this.username,userType:this.userType}));
    //     })
    //   }
    //   Promise.all(promiseList).then(sendResults =>{
    //     let msgList = [];
    //     sendResults.forEach(res => msgList.push(res.msg));
    //     msgList = [...new Set(msgList)];
    //     if(msgList.length === 1 && msgList[0] == '账号查询成功，密码发送成功'){
    //       this.$modal.msgSuccess('短信已成功发送！')
    //     }else if(msgList.length === 2){
    //       this.$modal.msgWarning('部分短信发送成功')
    //     }else{
    //       this.$modal.msgError('短信发送失败')
    //     }
    //   })
    // },
    doLogin(){
      this.$router.push({ path: "/login" });
    }
  }
}
</script>

<style scoped>
  .header{
    /* 矩形 136 */
    position: absolute;
    width: 100%;
    height: 81px;
    left: 0;
    right: 0;
    top: 0;
    bottom: 675px;
    background: linear-gradient(180.00deg, rgba(239,49,67,1) 0%,rgba(249,105,120,1) 100%);
  }
  .img_logo{
    /* 标识基础规范2：禾丰股份1 */
    position: absolute;
    width: 169px;
    height: 43px;
    left: 30px;
    right: 1081px;
    top: 10px;
    bottom: 687px;
  }
  .img_rectangle{
    /* 矩形 173 */
    position: absolute;
    width: 3px;
    height: 35px;
    left: 222px;
    right: 1055px;
    top: 14px;
    bottom: 691px;
  }
  .img_title{
    /* 小禾订货平台 */
    position: absolute;
    width: 226px;
    height: 56px;
    left: 186px;
    right: 856px;
    top: 14px;
    bottom: 682px;
  }
  .img_osp{
    /* OSP */
    position: absolute;
    float: right;
    width: 298px;
    height: 66px;
    right: 39px;
    top: 0;
    bottom: 672px;
  }
  .main{
    position: relative;
    top: 120px;
  }
  .text{
    /* 请选择要注册的账号 */
    position: absolute;
    height: 35px;
    left: 160px;
    right: 0;
    top: 0;
    bottom: 583px;

    background: linear-gradient(180.00deg, rgba(240,53,71,1) 0%,rgba(255,137.6,149.58,1) 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: 24px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
  }
  .input{
    /* 矩形 176 */
    position: relative;
    width: 315px;
    left: 120px;
    /*top: 68px;*/
    box-sizing: border-box;

    border: 1px solid rgb(196, 196, 196);
    border-radius: 5px;
  }
  .but1{
    position: relative;
    left: 136px;
    width: 148px;
    height: 45px;

    background: linear-gradient(180.00deg, rgba(248,102,117,1) 0%,rgba(239,51,69,1) 100%);
    border-radius: 5px;
    border: none;
  }
  .sp{
    /* 核对身份 */
    width: 274px;
    height: 31px;

    color: rgb(255, 255, 255);
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 1px;
  }
  .table{
    position: relative;
    left: 120px;
    width: 80%;
  }
  .but2{
    position: relative;
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 17px;
    border:1px solid rgb(196, 196, 196);
    border-bottom: none;
    border-radius: 0;
    background-color: white;
  }
  .three_lever{
    /* 减去顶层 */
    position: absolute;
    width: 14px;
    height: 16px;
  }
  .sp1{
    margin-left: 20px;
    font-size: 16px;
    color: rgb(71, 71, 71);
  }
  .but{
    /* 矩形 171 */
    position:relative;
    width: 326px;
    height: 42px;
    left: 120px;

    background: linear-gradient(180.00deg, rgba(243.97,80.92,96.73,1) 0%,rgba(253,131,145,1) 100%);
    border-radius: 20px;
    border: none;
  }
  .but5{
    background: linear-gradient(180.00deg, rgba(80,128,248,1) 0%,rgba(106,167,253,1) 100%);
  }
  .sp2{
    margin-left: 140px;
    color: rgb(156, 156, 156);
    font-size: 14px;
  }
  .div{
    margin-left: 120px;
    width: 80%;
  }
  .hf_logo2{
    position: absolute;
    bottom: 0;
    width: 800px;
    height: 600px;
  }
</style>
